import cn from 'classnames'
import { Typography } from '../Typography'
import { ReactComponent as Information16 } from 'assets/svg/Information.svg'
import { BannerProps } from './types'
import './banner.info.scss'

export const Info = ({ className, text, subtext }: BannerProps) => (
  <div
    className={cn(
      'banner banner--info row gap-12 align-center space-between',
      className
    )}
  >
    <div className="row gap-12 align-center align-start">
      <Information16 className="mt-2" />
      <div className="column">
        <Typography.Body2>{text}</Typography.Body2>
        {subtext && (
          <Typography.Caption className="mt-8">{subtext}</Typography.Caption>
        )}
      </div>
    </div>
  </div>
)
